<template>
  <div class="container" :class="getUserType == 0 ? 'margin-flag-b2c-select1' : ''">
    <CentralItemsContainer>
      <TeamItem v-for="team in teams" :key="team.id" :team="team" @click="onTeamItemClicked" />
    </CentralItemsContainer>
  </div>
</template>

<script>
import CentralItemsContainer from '@/components/Elements/CentralItemsContainer';
import TeamItem from '@/components/Elements/TeamItem';
import { mapGetters } from 'vuex';
import { analisisDeEquipo } from '@/utils/analytics/teams';
import { analisisDeJugadoresElegirEquipo } from '@/utils/analytics/players';
import { getLocalStorageSeasonSelected } from '@/utils/misc';

export default {
  name: 'Teams',
  components: {
    CentralItemsContainer,
    TeamItem,
  },
  computed: {
    ...mapGetters('teamsGeneral', ['teams']),
    ...mapGetters('loginGeneral', ['seasonId', 'getSeasonSelected', 'getUserType']),
  },
  watch: {
    getSeasonSelected(newValue) {
      this.$store.dispatch('teamsGeneral/getTeamsBySeason', newValue);
    },
  },
  methods: {
    onTeamItemClicked(team) {
      if (this.$route.meta.to === 'players') {
        analisisDeJugadoresElegirEquipo(team.team_id);
        this.$router.push(`/playersAnalysis/teams/${team.team_id}?teamName=${team.colloquial_name}`);
      } else {
        analisisDeEquipo(team.team_id);
        this.$router.push({ name: 'team', params: { teamId: team.team_id } });
      }
    },
  },
  async mounted() {
    try {
      window.scrollTo(0, 0);
      await this.$store.dispatch('teamsGeneral/getTeamsBySeason', getLocalStorageSeasonSelected() || this.seasonId);
    } catch (e) {
      console.error(e);
    }
  },
};
</script>
<style>
.margin-flag-b2c-select1 {
  margin-bottom: 50px !important;
  margin-top: 40px !important;
}
.page-title {
  text-transform: uppercase;
}
</style>
